// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9ac03a82","239":"d0808786","667":"efd5587a"}[chunkId] + ".chunk.js";
};